/**
 * @returns {boolean}
 */
export function isDeviceTypeLenovoTB_X306X(): boolean {
  return /Lenovo TB-X306X/i.test(window.navigator.userAgent);
}
